import { Loader } from "./Loader";

export const GenericLoader = ({ logo, width, height, color, sellerPageLoaderImage }) => {
    return (
        <Loader color={color}>
            <img
                src={sellerPageLoaderImage || logo}
                onError={(e) => {
                    e.target.src = logo;
                    e.target.onError = null;
                }}
                alt="Loading..."
                style={{
                    width: width || "auto",
                    height: height || "auto"
                }}
            />
        </Loader>
    );
}; 